import moment from 'moment/moment';
// - Import action types
import { VoteActionType } from 'constants/voteActionType';
// - Import actions
import * as globalActions from 'store/actions/globalActions';
import * as notifyActions from 'store/actions/notifyActions';
import * as postActions from 'store/actions/postActions';
import { SocialProviderTypes } from 'src/core/socialProviderTypes';
import { provider } from 'src/socialEngine';
/**
 * Get service providers
 */
var voteService = provider.get(SocialProviderTypes.VoteService);
/* _____________ CRUD DB _____________ */
/**
 *  Add vote to database
 * @param  {string} postId is the identifier of the post which user vote
 * @param  {string} ownerPostUserId is the identifier of the post owner which user vote
 */
export var dbAddVote = function (postId, ownerPostUserId) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var currentUser = state.getIn(['user', 'info', uid]);
        var vote = {
            postId: postId,
            creationDate: moment().unix(),
            userDisplayName: currentUser.fullName,
            userAvatar: currentUser.avatar,
            userId: uid
        };
        var post = state.getIn(['post', 'userPosts', ownerPostUserId, postId]);
        var score = Number(post.get('score', 0)) + 1;
        var votedPost = post
            .set('score', score)
            .setIn(['votes', uid], true);
        dispatch(postActions.updatePost(votedPost));
        return voteService.addVote(vote).then(function (voteKey) {
            if (uid !== ownerPostUserId) {
                dispatch(notifyActions.dbAddNotification({
                    description: 'Liked your post.',
                    url: "/" + ownerPostUserId + "/posts/" + postId,
                    notifyRecieverUserId: ownerPostUserId, notifierUserId: uid,
                    isSeen: false
                }));
            }
        })
            .catch(function (error) {
            var score = post.get('score', 0) - 1;
            var votedPost = post
                .set('score', score)
                .setIn(['votes', uid], false);
            dispatch(postActions.updatePost(votedPost));
            dispatch(globalActions.showMessage(error.message));
        });
    };
};
export var dbAddPurchase = function (postId, ownerPostUserId) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var currentUser = state.getIn(['user', 'info', uid]);
        var vote = {
            postId: postId,
            creationDate: moment().unix(),
            userDisplayName: currentUser.fullName,
            userAvatar: currentUser.avatar,
            userId: uid
        };
        var post = state.getIn(['post', 'userPosts', ownerPostUserId, postId]);
        var score = Number(post.get('score', 0)) + 1;
        var votedPost = post
            .set('score', score)
            .setIn(['votes', uid], true);
        dispatch(postActions.updatePost(votedPost));
        return voteService.addVote(vote).then(function (voteKey) {
            if (uid !== ownerPostUserId) {
                dispatch(notifyActions.dbAddNotification({
                    description: 'Liked your post.',
                    url: "/" + ownerPostUserId + "/posts/" + postId,
                    notifyRecieverUserId: ownerPostUserId, notifierUserId: uid,
                    isSeen: false
                }));
            }
        })
            .catch(function (error) {
            var score = post.get('score', 0) - 1;
            var votedPost = post
                .set('score', score)
                .setIn(['votes', uid], false);
            dispatch(postActions.updatePost(votedPost));
            dispatch(globalActions.showMessage(error.message));
        });
    };
};
/**
 * Get all votes from database
 */
export var dbGetVotes = function (userId, postId) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (uid) {
            return voteService
                .getVotes(postId)
                .then(function (postVotes) {
                dispatch(addVoteList(postVotes));
                var post = state.getIn(['post', 'userPosts', userId, postId]);
                if (!post) {
                    return;
                }
                var votes = postVotes[postId];
                if (votes && Object.keys(votes).length > 0) {
                    post.score = Object.keys(votes).length;
                }
            });
        }
    };
};
/**
 * Delete a vote from database
 * @param  {string} id of vote
 * @param {string} postId is the identifier of the post which vote belong to
 */
export var dbDeleteVote = function (postId, ownerPostUserId) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var post = state.getIn(['post', 'userPosts', ownerPostUserId, postId]);
        var score = post.get('score', 0) - 1;
        var votedPost = post
            .set('score', score)
            .setIn(['votes', uid], false);
        dispatch(postActions.updatePost(votedPost));
        return voteService.deleteVote(uid, postId).then(function (x) { return x; })
            .catch(function (error) {
            var score = post.get('score', 0) + 1;
            var votedPost = post
                .set('score', score)
                .setIn(['votes', uid], true);
            dispatch(postActions.updatePost(votedPost));
            dispatch(globalActions.showMessage(error.message));
        });
    };
};
/**
 * Add a vote
 * @param {Vote} vote
 */
export var addVote = function (vote) {
    return { type: VoteActionType.ADD_VOTE, payload: vote };
};
/**
 * delete a vote
 * @param {string} id vote identifier
 * @param {string} postId post identifier which vote on
 */
export var deleteVote = function (userId, postId) {
    return { type: VoteActionType.DELETE_VOTE, payload: { userId: userId, postId: postId } };
};
/**
 * Ad a list of vote
 * @param {[postId:string]: {[voteId: string]: Vote}} votes a list of vote
 */
export var addVoteList = function (votes) {
    return { type: VoteActionType.ADD_VOTE_LIST, payload: votes };
};
/**
 * Clear all data
 */
export var clearAllvotes = function () {
    return { type: VoteActionType.CLEAR_ALL_DATA_VOTE };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/voteActions.ts
// module id = 394
// module chunks = 50